import React from 'react';
import { Link } from 'react-router-dom';
import { FiHeart } from 'react-icons/fi';
import * as styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerSection}>
          <h3>QR Butler</h3>
          <p>Streamline your restaurant's ordering process with QR code technology.</p>
        </div>
        
        <div className={styles.footerSection}>
          <h4>Quick Links</h4>
          <ul className={styles.footerLinks}>
            <li><Link to="/" className={styles.footerLink}>Home</Link></li>
            <li><Link to="/dashboard" className={styles.footerLink}>Dashboard</Link></li>
            <li><Link to="/login" className={styles.footerLink}>Login</Link></li>
            <li><Link to="/signup" className={styles.footerLink}>Sign Up</Link></li>
          </ul>
        </div>
        
        <div className={styles.footerSection}>
          <h4>Legal</h4>
          <ul className={styles.footerLinks}>
            <li><Link to="/terms" className={styles.footerLink}>Terms of Service</Link></li>
            <li><Link to="/privacy" className={styles.footerLink}>Privacy Policy</Link></li>
          </ul>
        </div>
        
        <div className={styles.footerSection}>
          <h4>Support</h4>
          <ul className={styles.footerLinks}>
            <li><a href="mailto:support@qrbutler.com" className={styles.footerLink}>Contact Support</a></li>
            <li><a href="tel:+1-555-0123" className={styles.footerLink}>Call Us</a></li>
          </ul>
        </div>
      </div>
      
      <div className={styles.footerBottom}>
        <p>
          &copy; {new Date().getFullYear()} QR Butler. Made with <FiHeart className={styles.heart} /> for restaurants.
        </p>
      </div>
    </footer>
  );
};

export default Footer;